import { streamsRepository } from '@/repositories/api/streamsRepository'
import { cvProcessRepository } from '@/repositories/api/cvProcessRepository'

const repositories = {
  streams: streamsRepository,
  cvProcess: cvProcessRepository
}

export const apiRepositoryFactory = {
  get: (key) => repositories[key],
}
